import {
  SUPPORTTICKETS_REQUEST, SUPPORTTICKETS_SUCCESS, SUPPORTTICKETS_FAILURE,
  SUPPORTTICKET_REQUEST, SUPPORTTICKET_SUCCESS, SUPPORTTICKET_FAILURE,
  SUPPORTTICKET_ADD_REQUEST, SUPPORTTICKET_ADD_SUCCESS, SUPPORTTICKET_ADD_FAILURE,
  SUPPORTTICKET_DELETE_REQUEST, SUPPORTTICKET_DELETE_SUCCESS, SUPPORTTICKET_DELETE_FAILURE,
  SUPPORTTICKET_CLOSE_REQUEST, SUPPORTTICKET_CLOSE_SUCCESS, SUPPORTTICKET_CLOSE_FAILURE,
  SUPPORTTICKET_REVIEW_REQUEST, SUPPORTTICKET_REVIEW_SUCCESS, SUPPORTTICKET_REVIEW_FAILURE,
  SUPPORTTICKET_RESOLVE_REQUEST, SUPPORTTICKET_RESOLVE_SUCCESS, SUPPORTTICKET_RESOLVE_FAILURE,
  SUPPORTTICKET_INCIDENCE_REQUEST, SUPPORTTICKET_INCIDENCE_SUCCESS, SUPPORTTICKET_INCIDENCE_FAILURE,
  SUPPORTTICKET_REPAIR_REQUEST, SUPPORTTICKET_REPAIR_SUCCESS, SUPPORTTICKET_REPAIR_FAILURE
} from '../actions/supporttickets'

const INITIAL_STATE = {
  supporttickets: null, supportticket: null, error: null, loading: false, supportticketNeedRefresh: false
}

const supportticketsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case SUPPORTTICKETS_REQUEST:
        return {
          ...state,
          error: null, loading: true, supportticketNeedRefresh: false
        }
      case SUPPORTTICKETS_SUCCESS:
        return {
          ...state,
          supporttickets: action.response, error: null, loading: false, supportticketNeedRefresh: false
        }
      case SUPPORTTICKETS_FAILURE:
        return {
          ...state,
          error: action.error, loading: false
        }
      case SUPPORTTICKET_REQUEST:
        return {
          ...state,
          error: null, loading: true
        }
      case SUPPORTTICKET_SUCCESS:
        return {
          ...state,
          supportticket: action.response, error: null, loading: false
        }
      case SUPPORTTICKET_FAILURE:
        return {
          ...state,
          error: action.error, loading: false
        }
      case SUPPORTTICKET_ADD_REQUEST:
        return {
          ...state,
          error: null, loading: true
        }
      case SUPPORTTICKET_ADD_SUCCESS:
        return {
          ...state,
          supportticketNeedRefresh: true, supportticket: action.response, error: null, loading: false
        }
      case SUPPORTTICKET_ADD_FAILURE:
        return {
          ...state,
          error: action.error, loading: false
        }
      case SUPPORTTICKET_DELETE_REQUEST:
        return {
          ...state,
          error: null, loading: true
        }
      case SUPPORTTICKET_DELETE_SUCCESS:
        return {
          ...state,
          supportticketNeedRefresh: true, supportticket: null, error: null, loading: false
        }
      case SUPPORTTICKET_DELETE_FAILURE:
        return {
          ...state,
          error: action.error, loading: false
        }
      case SUPPORTTICKET_CLOSE_REQUEST:
      case SUPPORTTICKET_REVIEW_REQUEST:
      case SUPPORTTICKET_RESOLVE_REQUEST:
      case SUPPORTTICKET_INCIDENCE_REQUEST:
      case SUPPORTTICKET_REPAIR_REQUEST:
        return {
          ...state,
          error: null, loading: true
        }
      case SUPPORTTICKET_CLOSE_SUCCESS:
      case SUPPORTTICKET_REVIEW_SUCCESS:
      case SUPPORTTICKET_RESOLVE_SUCCESS:
      case SUPPORTTICKET_INCIDENCE_SUCCESS:
      case SUPPORTTICKET_REPAIR_SUCCESS:
        return {
          ...state,
          supportticketNeedRefresh: true, supporttickets: null, error: null, loading: false
        }
      case SUPPORTTICKET_CLOSE_FAILURE:
      case SUPPORTTICKET_REVIEW_FAILURE:
      case SUPPORTTICKET_RESOLVE_FAILURE:
      case SUPPORTTICKET_INCIDENCE_FAILURE:
      case SUPPORTTICKET_REPAIR_FAILURE:
        return {
          ...state,
          error: action.error, loading: false
        }
      default:
        return state
    }
  }

export default supportticketsReducer

